var floatingBanner = (function() {
  function init() {
    uiBindings();
  }

  var uiBindings = function() {
    var guideFloatingBanner = document.getElementById("guide-floating-banner"),
      longFormFloatingBanner = document.getElementById("lg-floating-banner"),
      dgFloatingBanner = document.getElementById("dg-floating-banner"),
      liveURLFloatingBanner = document.getElementById("guide-floating-url-banner"),
      cookieNotification = document.getElementById('cookie-notification');

      if (dgFloatingBanner) {
        var ctafloatingBanner = document.querySelector('.dg-floating-banner a.btn'),
          closefloatingBanner = document.querySelector('.dg-floating-banner span.close');

        ctafloatingBanner.addEventListener('click', function () {
          WebEventTracker.logEvent(EDS.webEvents, floatingBannerEvents.click, {
            action: 'click',
          });
        });
        if (closefloatingBanner) {
          closefloatingBanner.addEventListener('click', function () {
            WebEventTracker.logEvent(EDS.webEvents, floatingBannerEvents.close, {
              action: 'click',
            });
          });
        }
      }

    window.addEventListener("load", function() {
      var singleGuide = document.querySelector(".single-guide"),
        LongFormPage = document.querySelector(".page-template-long-form-doc"),
        dgCampaignPage = document.querySelector(".page-template-campaign"),
        consentBanner = document.getElementById("consent-banner");
        
      if (
        ((singleGuide || LongFormPage) && (
          window.innerWidth >= 640 &&
          (Cookie.read(stage_env_cookie_prefix + 'UserOptCookie') && !enableTrustArcCCM ) || (enableTrustArcCCM && !wpUserLoggedIn && consentBanner && consentBanner.children.length === 0))) ||
        dgCampaignPage
      ) {
        var hideFloatingBanner = Cookie.read('hideFloatingBanner');
        if (hideFloatingBanner == undefined || hideFloatingBanner == 'undefined' || hideFloatingBanner == '') {
          setTimeout(function () {
            if (guideFloatingBanner) {
              guideFloatingBanner.style.display = 'block';
              setTimeout(function () {
                guideFloatingBanner.style.bottom = '20px';
              }, 100);
            }
            if (longFormFloatingBanner) {
              longFormFloatingBanner.style.display = 'block';
              setTimeout(function () {
                longFormFloatingBanner.style.bottom = '20px';
              }, 100);
            }
            if (dgFloatingBanner) {
              dgFloatingBanner.style.display = 'block';
              if (Cookie.read(stage_env_cookie_prefix + 'UserOptCookie') && !enableTrustArcCCM ) {
                dgFloatingBanner.style.bottom = '20px';
              } else if(enableTrustArcCCM && !wpUserLoggedIn && consentBanner && consentBanner.children.length !== 0){
                dgFloatingBanner.style.bottom = '90px';
              } else {
                dgFloatingBanner.style.bottom = '90px';
              }
            }
            if (liveURLFloatingBanner) {
              liveURLFloatingBanner.style.display = 'block';
              if (cookieNotification && !cookieNotification.classList.contains('hide') && !enableTrustArcCCM) {
                setTimeout(function () {
                  liveURLFloatingBanner.style.bottom = '80px';
                }, 100);
              } else if (enableTrustArcCCM && !wpUserLoggedIn && consentBanner && consentBanner.children.length !== 0){
                setTimeout(function () {
                  liveURLFloatingBanner.style.bottom = '90px';
                }, 100);
              } else {
                setTimeout(function () {
                  liveURLFloatingBanner.style.bottom = '0px';
                }, 100);
              }
            }

            //show images from lazy load
            lazyLoading.show();
          }, 5000);

          window.addEventListener('scroll', function () {
            var scroll = window.pageYOffset;
            var headerHeight = document.getElementById('header-habitat').offsetHeight - 63;
            var bottomScrollHeight = document.getElementById('footer-habitat').offsetTop;
            if (document.getElementById('guide-related-posts')) {
              bottomScrollHeight = document.getElementById('guide-related-posts').offsetTop;
            } else if (document.querySelector('.long-form-cta')) {
              bottomScrollHeight = document.querySelector('.long-form-cta').offsetTop;
            }

            if (scroll + window.innerHeight > bottomScrollHeight || scroll <= headerHeight) {
              if (guideFloatingBanner) {
                setTimeout(function () {
                  guideFloatingBanner.style.bottom = '-100px';
                }, 150);
              }
              if (longFormFloatingBanner) {
                setTimeout(function () {
                  longFormFloatingBanner.style.bottom = '-100px';
                }, 150);
              }
              if (liveURLFloatingBanner) {
                setTimeout(function () {
                  liveURLFloatingBanner.style.bottom = '-150px';
                }, 150);
              }
            } else {
              if (cookieNotification && cookieNotification.classList.contains('hide') && !enableTrustArcCCM) {
                if (guideFloatingBanner) {
                  guideFloatingBanner.style.display = 'block';
                  setTimeout(function () {
                    guideFloatingBanner.style.bottom = '20px';
                  }, 100);
                }
                if (longFormFloatingBanner) {
                  longFormFloatingBanner.style.display = 'block';
                  setTimeout(function () {
                    longFormFloatingBanner.style.bottom = '20px';
                  }, 100);
                }
                if (liveURLFloatingBanner) {
                  liveURLFloatingBanner.style.display = 'block';
                  setTimeout(function () {
                    liveURLFloatingBanner.style.bottom = '0px';
                  }, 100);
                }
              } else if (enableTrustArcCCM && !wpUserLoggedIn && consentBanner && consentBanner.children.length !== 0) { 
                if (guideFloatingBanner) {
                  guideFloatingBanner.style.display = 'block';
                  setTimeout(function () {
                    guideFloatingBanner.style.bottom = '90px';
                  }, 100);
                }
                if (longFormFloatingBanner) {
                  longFormFloatingBanner.style.display = 'block';
                  setTimeout(function () {
                    longFormFloatingBanner.style.bottom = '90px';
                  }, 100);
                }
                if (liveURLFloatingBanner) {
                  liveURLFloatingBanner.style.display = 'block';
                  setTimeout(function () {
                    liveURLFloatingBanner.style.bottom = '90px';
                  }, 100);
                }
              } else {
                if (guideFloatingBanner) {
                  guideFloatingBanner.style.display = 'block';
                  setTimeout(function () {
                    guideFloatingBanner.style.bottom = '100px';
                  }, 100);
                }
                if (longFormFloatingBanner) {
                  longFormFloatingBanner.style.display = 'block';
                  setTimeout(function () {
                    longFormFloatingBanner.style.bottom = '100px';
                  }, 100);
                }
                if (liveURLFloatingBanner) {
                  liveURLFloatingBanner.style.display = 'block';
                  setTimeout(function () {
                    liveURLFloatingBanner.style.bottom = '80px';
                  }, 100);
                }
              }
            }
            if (dgFloatingBanner) {
              if (scroll + window.innerHeight > bottomScrollHeight) {
                dgFloatingBanner.style.bottom = '-150px';
              } else {
                dgFloatingBanner.style.display = 'block';
                if (Cookie.read(stage_env_cookie_prefix + 'UserOptCookie') && !enableTrustArcCCM) {
                  dgFloatingBanner.style.bottom = '20px';
                } else if (enableTrustArcCCM && !wpUserLoggedIn && consentBanner && consentBanner.children.length !== 0) {
                  dgFloatingBanner.style.bottom = '90px';
                } else {
                  dgFloatingBanner.style.bottom = '90px';
                }
              }
            }
          });

          if (guideFloatingBanner) {
            document.getElementById('close-guide-floating-banner').addEventListener('click', setFloatingBannerCookie);
          }

          if (longFormFloatingBanner) {
            document.getElementById('close-lg-floating-banner').addEventListener('click', setFloatingBannerCookie);
          }

          if (dgFloatingBanner && document.getElementById('close-dg-floating-banner')) {
            document.getElementById('close-dg-floating-banner').addEventListener('click', setFloatingBannerCookie);
          }

          if (liveURLFloatingBanner) {
            document
              .getElementById('close-live-url-floating-banner')
              .addEventListener('click', setFloatingBannerCookie);
          }

          function setFloatingBannerCookie() {
            //Adding cookie
            var d = new Date(),
              cookieApproved = Cookie.read(stage_env_cookie_prefix + 'UserOptCookie'),
              customWidgetContainer = document.getElementById('custom-fc-frame'),
              freshChatBubble = document.getElementById('freshchat-bubble');

            d.setTime(d.getTime() + 24 * 60 * 60 * 1000); //For 1 Day
            document.cookie = 'hideFloatingBanner=1;expires=' + d.toUTCString() + ';path=' + window.location.pathname;

            if (guideFloatingBanner) {
              guideFloatingBanner.remove();
              // set freshchat position
              if (window.innerWidth <= 1024) {
                if (cookieApproved === null) {
                  customWidgetContainer ? (customWidgetContainer.style.bottom = '110px') : '';
                  freshChatBubble ? (freshChatBubble.style.bottom = '185px') : '';
                } else {
                  customWidgetContainer ? customWidgetContainer.removeAttribute('style') : '';
                  freshChatBubble ? freshChatBubble.removeAttribute('style') : '';
                }
              }
            }
            if (longFormFloatingBanner) {
              longFormFloatingBanner.remove();
            }
            if (liveURLFloatingBanner) {
              liveURLFloatingBanner.remove();
            }
            if (dgFloatingBanner) {
              dgFloatingBanner.remove();
            }
          }
        }
      }
    });
  };

  init();
})();
